
export const boolOptionsModel = {
    isARCV: false,
    isReport: false,
    isUserManagement: false,
    isHome: true,
}
